import styled from 'styled-components'

export const Container = styled.div`
  color: ${props => props.theme.colors.color6b7786};
  font-size: 14px;
  font-weight: bold;
  margin-top: 18px;
  > hr {
    width: 100%;
    margin-top: 10px;
    color: ${props => props.theme.colors.color6b7786};
    border: 1px solid ${props => props.theme.colors.color6b7786};
  }
`
